(function () {
  'use strict';

  function initBuyBox(root) {
    if (root.dataset.vpBuyboxInit === 'true') return;
    root.dataset.vpBuyboxInit = 'true';

    var panels = root.querySelectorAll('[data-vp-panel]');

    // Flavor switching — chips exist inside every panel so state stays in sync
    root.addEventListener('click', function (event) {
      var chip = event.target.closest('[data-vp-flavor]');
      if (!chip) return;
      var target = chip.getAttribute('data-vp-flavor');
      panels.forEach(function (panel) {
        var isTarget = panel.getAttribute('data-vp-panel') === target;
        panel.classList.toggle('is-active', isTarget);
        if (isTarget) {
          panel.removeAttribute('hidden');
        } else {
          panel.setAttribute('hidden', '');
        }
      });
    });

    panels.forEach(function (panel) {
      // Gallery thumbnails
      var mainImage = panel.querySelector('[data-vp-main-image]');
      panel.querySelectorAll('[data-vp-thumb]').forEach(function (thumb) {
        thumb.addEventListener('click', function () {
          if (!mainImage) return;
          var full = thumb.getAttribute('data-full');
          if (full) {
            mainImage.src = full;
            mainImage.removeAttribute('srcset');
          }
          panel.querySelectorAll('[data-vp-thumb]').forEach(function (t) {
            t.classList.toggle('is-active', t === thumb);
          });
        });
      });

      // Purchase option toggle → native selling_plan input
      var sellingPlanInput = panel.querySelector('[data-vp-selling-plan-input]');
      var sellingPlanProperty = panel.querySelector('[data-selling-plan-property]');
      panel.querySelectorAll('[data-vp-purchase-option]').forEach(function (radio) {
        radio.addEventListener('change', function () {
          if (!radio.checked) return;
          var isSubscription = radio.value === 'subscription';
          if (sellingPlanInput) {
            sellingPlanInput.value = isSubscription ? radio.getAttribute('data-selling-plan-id') || '' : '';
          }
          if (sellingPlanProperty) {
            sellingPlanProperty.value = isSubscription ? 'subscription' : 'one-time';
          }
          panel.querySelectorAll('.vp-o1-buybox__purchase-option').forEach(function (label) {
            var input = label.querySelector('input[type="radio"]');
            label.classList.toggle('is-active', input === radio);
          });
        });
      });

      // Nutrition label toggle (open by default on desktop, collapsed on mobile)
      var nutritionToggle = panel.querySelector('[data-vp-nutrition-toggle]');
      if (nutritionToggle) {
        var nutritionPanel = panel.querySelector('[data-vp-nutrition-panel]');
        var labelShow = nutritionToggle.querySelector('[data-label-show]');
        var labelHide = nutritionToggle.querySelector('[data-label-hide]');
        if (window.matchMedia('(max-width: 989px)').matches) {
          nutritionToggle.setAttribute('aria-expanded', 'false');
          nutritionToggle.classList.remove('is-open');
          if (nutritionPanel) nutritionPanel.setAttribute('hidden', '');
          if (labelShow) labelShow.hidden = false;
          if (labelHide) labelHide.hidden = true;
        }
        nutritionToggle.addEventListener('click', function () {
          var expanded = nutritionToggle.getAttribute('aria-expanded') === 'true';
          nutritionToggle.setAttribute('aria-expanded', String(!expanded));
          nutritionToggle.classList.toggle('is-open', !expanded);
          if (nutritionPanel) {
            if (expanded) {
              nutritionPanel.setAttribute('hidden', '');
            } else {
              nutritionPanel.removeAttribute('hidden');
            }
          }
          if (labelShow) labelShow.hidden = !expanded;
          if (labelHide) labelHide.hidden = expanded;
        });
      }

      // Accordions
      panel.querySelectorAll('[data-vp-accordion]').forEach(function (toggle) {
        toggle.addEventListener('click', function () {
          var expanded = toggle.getAttribute('aria-expanded') === 'true';
          toggle.setAttribute('aria-expanded', String(!expanded));
          toggle.classList.toggle('is-open', !expanded);
          var content = toggle.nextElementSibling;
          if (content) {
            if (expanded) {
              content.setAttribute('hidden', '');
            } else {
              content.removeAttribute('hidden');
            }
          }
        });
      });
    });
  }

  function initAll() {
    document.querySelectorAll('[data-vp-buybox]').forEach(initBuyBox);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initAll);
  } else {
    initAll();
  }

  document.addEventListener('shopify:section:load', initAll);
})();
